import { render, staticRenderFns } from "./Processes.vue?vue&type=template&id=f6c44f9c"
import script from "./Processes.vue?vue&type=script&lang=js"
export * from "./Processes.vue?vue&type=script&lang=js"
import style0 from "./Processes.vue?vue&type=style&index=0&id=f6c44f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports